import React from 'react'
import { DiffViewer } from 'components/organisms'
import { useEditorContext } from 'context/EditorContext';

const SideNavJSON = () => {
  const [{ sidenav, sidenavPrevious }] = useEditorContext();

  return (
    <DiffViewer
      oldCode={JSON.stringify(sidenavPrevious, null, 2)}
      newCode={JSON.stringify(sidenav, null, 2)}
      hasEdited={false}
    />
  )
}

export default SideNavJSON
